import React, { useEffect, useState } from "react";
import {
  Box,
  Card,
  CardContent,
  Typography,
  Chip,
  Grid,
  IconButton,
  Tooltip,
  Backdrop,
  CircularProgress,
} from "@mui/material";
import { Email, Phone, WhatsApp } from "@mui/icons-material";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import CallIcon from "@mui/icons-material/Call";
import CustomSnackbar from "../../../newTestPrep/components/ui-component/snackbar/CustomSnackbar";
import CancelIcon from "@mui/icons-material/Cancel";
import CheckIcon from "@mui/icons-material/Check";
import MassEnquiryTransferButton from "../../../newTestPrep/newComponent/NewButtonComp/MassEnquiryTransferButton";
import CustomPopup from "../../../components/CustomPopup";
import RecycleOneEnquiryTransfer from "../../../newTestPrep/components/DataTransferComp.jsx/RecycleOneEnquiryTransfer";
import CancelRecycleRequest from "../../../newTestPrep/components/DataTransferComp.jsx/CancelRecycleRequest";
import RemoveRedEyeOutlinedIcon from "@mui/icons-material/RemoveRedEyeOutlined";
import VisibilityOffOutlinedIcon from "@mui/icons-material/VisibilityOffOutlined";
import { useGetTokenOrLogout } from "../../../utils/token";
import AcceptConfirmationPopup from "../../../newTestPrep/pages/RecycleRequest/AcceptConfirmationPopup";
import AcceptRecycleWithNote from "../../../newTestPrep/pages/RecycleRequest/AcceptRecycleWithNote";

const API_ENDPOINT = process.env.REACT_APP_API_ENDPOINT;

const EnquiryDetailsCard = ({ enquiryData }) => {
  const userId = localStorage.getItem("userId");
  const userRole = localStorage.getItem("userRole");
  const {
    id,
    first_name,
    last_name,
    status,
    email,
    mobile,
    mobile_country_code,
    whatsapp_country_code,
    whatsapp_number,
    test_type,
    course,
    advisor_name,
    advisor_id,
    assign_to,
    test_type_id,
    prospective_level_id,
    sub_service_id,
    sub_service,
  } = enquiryData;

  const getTokenOrLogout = useGetTokenOrLogout();
  const [recycleRequest, setRecycleRequest] = useState(null);

  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");
  const [openEnquiryTransfer, setOpenEnquiryTransfer] = useState(false);
  const [openCancelpopup, setOpenCancelPopup] = useState(false);
  const [showMobile, setShowMobile] = useState(false);
  const [showSecondaryMobile, setShowSecondaryMobile] = useState(false);
  const [showWhatsAppNumber, setShowWhatAppNumber] = useState(false);
  const [loading, setLoading] = useState(false);
  const [openAccept, setOpenAccept] = useState(false);
  const recycleRequestId = enquiryData?.recycle_req_id?.id;

  const handleOpenEnquiryTransfer = () => {
    setOpenEnquiryTransfer(true);
  };

  const handlecloseEnquiryTransfer = () => {
    setOpenEnquiryTransfer(false);
  };

  const handleOpenCancelPopup = () => {
    setOpenCancelPopup(true);
  };

  const handleCloseCancelPopup = () => {
    setOpenCancelPopup(false);
  };

  const showSnackbar = (message, severity) => {
    setSnackbarMessage(message);
    setSnackbarSeverity(severity);
    setSnackbarOpen(true);
  };

  const handleClickToCall = () => {
    const data = {
      user_id: parseInt(userId),
      enquiry_id: id,
    };

    // Access the authorization token from environment variables
    const authToken = process.env.REACT_APP_CALL_TOKEN;

    // Send the POST request to the server
    fetch(`${API_ENDPOINT}clicktocall`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    })
      .then((response) => {
        if (response.ok) {
          showSnackbar("Call Connected", "success");
          alert("Call Connected");
        } else {
          showSnackbar("Call Not Connected", "error");
          alert("Call Not Connected");
        }
      })
      .catch((error) => {
        console.error("Error submitting data:", error);
        showSnackbar("Call Not Connected", "error");
        alert("Error Connecting Call");
      });
  };

  const handleCancelRecycleRequest = () => {
    const data = {
      user_id: parseInt(userId),
      //enquiry_id: id,
      status: "cancelled",
      is_active: false,
    };

    // Send the POST request to the server
    fetch(`${API_ENDPOINT}recyclerequest/updatebyEnquiryId/${id}`, {   
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    })
      .then((response) => {
        if (response.ok) {
          showSnackbar("Recycle Request cancelled successfully", "success");
          alert("Recycle Request cancelled successfully");
          window.location.reload();
        } else {
          showSnackbar("Error cancelling recycle request", "error");
          alert("Error cancelling recycle request");
        }
      })
      .catch((error) => {
        console.error("Error submitting data:", error);
        showSnackbar(
          "Network Error cancelling recycle request. Please try again",
          "error"
        );
        alert("Network Error cancelling recycle request. Please try again");
      });
  };

  

  useEffect(() => {
    fetch(`${API_ENDPOINT}recyclerequest/fetchbyEnquiryId/${id}`)
      .then((response) => response.json())
      .then((data) => {
        // data.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));

        setRecycleRequest(data);
      })
      .catch((error) => {
        console.error("Error fetching requests items:", error);
      });
  }, [id]);

  const handleShowMobile = () => {
    handleSubmit(() => setShowMobile(true));
  };

  const handleHideMobile = () => {
    setShowMobile(false);
  };

  const handleShowSecondaryMobile = () => {
    handleSubmit(() => setShowSecondaryMobile(true));
  };

  const handleHideSecondaryMobile = () => {
    setShowSecondaryMobile(false);
  };

  const handleShowWhatsAppMobile = () => {
    handleSubmit(() => setShowWhatAppNumber(true));
  };

  const handleHideWhatsAppMobile = () => {
    setShowWhatAppNumber(false);
  };

  const handleSubmit = async (onSuccessCallback) => {
    setLoading(true);
    const token = getTokenOrLogout();
    if (!token) return;
    let headers = {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json", // Make sure to keep the content type
    };

    const requestData = {
      user_id: parseInt(userId),
      enquiry_id: id,
    };

    try {
      const response = await fetch(`${API_ENDPOINT}show-enq-mobile`, {
        method: "POST",
        headers,
        body: JSON.stringify(requestData),
      });

      const result = await response.json();
      if (response.ok) {
        setLoading(false);
        if (typeof onSuccessCallback === "function") {
          onSuccessCallback();
        }
      } else {
        showSnackbar(result.message, "error");
        setLoading(false);
      }
    } catch (error) {
      showSnackbar("Server Error", "error");
      setLoading(false);
    }
  };

  const handleOpenAcceptPopup = () => {
    setOpenAccept(true);
  };

  const handleCloseAcceptPopup = () => {
    setOpenAccept(false);
  };

  // Approve Recycle Request
  const handleApproveRecycle = async () => {
    const requestData = {
      user_id: parseInt(userId),
      recycle_request_id: [recycleRequestId],
    };

    try {
      const response = await fetch(
        `${API_ENDPOINT}recyclerequest/recycle-approve`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json", // Make sure to keep the content type
          },
          body: JSON.stringify(requestData),
        }
      );

      let data = await response.json();

      if (response.ok) {
        showSnackbar("Data Updated Successfully", "success");

        setTimeout(() => {
          window.location.reload();
        }, 1500);
      } else if (response.status === 400) {
        showSnackbar(data.message, "error");
      } else if (response.status === 401) {
        showSnackbar(data.message, "error");
      } else if (response.status === 403) {
        showSnackbar(data.message, "error");
      } else if (response.status === 500) {
        showSnackbar("Server Error", "error");
      } else {
        showSnackbar("Server Error", "error");
      }
    } catch (error) {
      showSnackbar("Server Error", "error");
    }
  };

  return (
    <>
      <Backdrop open={loading} style={{ zIndex: 9999 }}>
        <Typography variant="h4" color="error" fontWeight={800} marginRight={2}>
          Processing Mobile Number Request...
        </Typography>
        <CircularProgress color="primary" />
      </Backdrop>

      <Card style={{ padding: "10px" }}>
        <Box display="flex" justifyContent="space-between">
          <Box display="flex" alignItems="center" gap={1}>
            <Typography variant="h4">
              {first_name} {last_name}
            </Typography>

            {prospective_level_id && (
              <Chip
                variant="contained"
                size="small"
                color="secondary"
                label={prospective_level_id?.prospective_level}
              />
            )}
            {recycleRequest && (
              <>
                <Chip
                  variant="contained"
                  size="small"
                  color="error"
                  label="Recycle Request Pending"
                />
                {(userRole === "data_entry" || userRole === "center_admin") && (
                  <>
                    <Tooltip title="Cancel Recycle Request" arrow>
                      <IconButton color="error" onClick={handleOpenCancelPopup}>
                        <CancelIcon fontSize="small" />
                      </IconButton>
                    </Tooltip>

                    <Tooltip title="Accept Recycle Request" arrow>
                      <IconButton
                        color="secondary"
                        onClick={handleOpenAcceptPopup}
                      >
                        <CheckIcon fontSize="small" />
                      </IconButton>
                    </Tooltip>
                  </>
                )}
              </>
            )}

            {prospective_level_id?.prospective_level === "Recycled" &&
              userRole === "data_entry" &&
              !recycleRequest && (
                <Tooltip title="Reopen  Enquiry" arrow>
                  <Box sx={{ cursor: "pointer" }}>
                    <img
                      src="/dashboardimages/transfer.png"
                      width={20}
                      onClick={() => handleOpenEnquiryTransfer()}
                    />
                  </Box>
                </Tooltip>
              )}
          </Box>

          <Box>
            <IconButton onClick={handleClickToCall} color="secondary">
              <CallIcon />
            </IconButton>
          </Box>
        </Box>
        <Box mt={2}>
          <Grid container spacing={2}>
            {email && (
              <Grid item xs={12} sm={6} md={4} lg={3}>
                <Typography variant="body1">
                  <strong>Email:</strong> {email}
                </Typography>
              </Grid>
            )}
            <Grid item xs={12} sm={6} md={4} lg={3}>
              <Typography
                variant="body1"
                display="flex"
                alignItems="center"
                gap={1}
              >
                {/* <strong>Mobile:</strong> {mobile_country_code}{(userRole==="advisor" || userRole==="trainer") ?mobile?.replace(/.(?=.{4,}$)/g, '*') :  mobile} */}
                <strong>Mobile: </strong>

                {userRole === "advisor" || userRole === "trainer" ? (
                  <>
                    {mobile_country_code}
                    {!showMobile
                      ? mobile?.replace(/.(?=.{4,}$)/g, "*")
                      : mobile}

                    {showMobile ? (
                      <RemoveRedEyeOutlinedIcon
                        fontSize="small"
                        onClick={handleHideMobile}
                        sx={{
                          cursor: "pointer",
                          fontSize: "1rem",
                          "&:hover": {
                            color: "rgb(33, 150, 243)",
                          },
                        }}
                      />
                    ) : (
                      <VisibilityOffOutlinedIcon
                        fontSize="small"
                        onClick={handleShowMobile}
                        sx={{
                          cursor: "pointer",
                          fontSize: "1rem",
                          "&:hover": {
                            color: "rgb(33, 150, 243)",
                          },
                        }}
                      />
                    )}
                  </>
                ) : (
                  <>
                    {mobile_country_code} {mobile}
                  </>
                )}
              </Typography>
            </Grid>
            {enquiryData?.secondary_mobile && (
              <Grid item xs={12} sm={6} md={4} lg={3}>
                <Typography
                  variant="body1"
                  display="flex"
                  alignItems="center"
                  gap={1}
                >
                  {/* <strong>Mobile:</strong> {mobile_country_code}{(userRole==="advisor" || userRole==="trainer") ?mobile?.replace(/.(?=.{4,}$)/g, '*') :  mobile} */}
                  <strong>Secondary Mobile: </strong>

                  {userRole === "advisor" || userRole === "trainer" ? (
                    <>
                      {enquiryData?.secondary_mobile_country_code}
                      {!showSecondaryMobile
                        ? enquiryData?.secondary_mobile?.replace(
                            /.(?=.{4,}$)/g,
                            "*"
                          )
                        : enquiryData?.secondary_mobile}

                      {showSecondaryMobile ? (
                        <RemoveRedEyeOutlinedIcon
                          fontSize="small"
                          onClick={handleHideSecondaryMobile}
                          sx={{
                            cursor: "pointer",
                            fontSize: "1rem",
                            "&:hover": {
                              color: "rgb(33, 150, 243)",
                            },
                          }}
                        />
                      ) : (
                        <VisibilityOffOutlinedIcon
                          fontSize="small"
                          onClick={handleShowSecondaryMobile}
                          sx={{
                            cursor: "pointer",
                            fontSize: "1rem",
                            "&:hover": {
                              color: "rgb(33, 150, 243)",
                            },
                          }}
                        />
                      )}
                    </>
                  ) : (
                    <>
                      {enquiryData?.secondary_mobile_country_code}{" "}
                      {enquiryData?.secondary_mobile}
                    </>
                  )}
                </Typography>
              </Grid>
            )}

            {whatsapp_number && (
              <Grid item xs={12} sm={6} md={4} lg={3}>
                <Typography
                  variant="body1"
                  display="flex"
                  alignItems="center"
                  gap={1}
                >
                  {/* <strong>WhatsApp:</strong> {whatsapp_country_code}{(userRole==="advisor" || userRole==="trainer") ?whatsapp_number?.replace(/.(?=.{4,}$)/g, '*') :  whatsapp_number} */}
                  <strong>Whatsapp : </strong>

                  {userRole === "advisor" || userRole === "trainer" ? (
                    <>
                      {mobile_country_code}
                      {!showWhatsAppNumber
                        ? whatsapp_number?.replace(/.(?=.{4,}$)/g, "*")
                        : whatsapp_number}

                      {showWhatsAppNumber ? (
                        <RemoveRedEyeOutlinedIcon
                          fontSize="small"
                          onClick={handleHideWhatsAppMobile}
                          sx={{
                            cursor: "pointer",
                            fontSize: "1rem",
                            "&:hover": {
                              color: "rgb(33, 150, 243)",
                            },
                          }}
                        />
                      ) : (
                        <VisibilityOffOutlinedIcon
                          fontSize="small"
                          onClick={handleShowWhatsAppMobile}
                          sx={{
                            cursor: "pointer",
                            fontSize: "1rem",
                            "&:hover": {
                              color: "rgb(33, 150, 243)",
                            },
                          }}
                        />
                      )}
                    </>
                  ) : (
                    <>
                      {mobile_country_code} {whatsapp_number}
                    </>
                  )}
                </Typography>
              </Grid>
            )}
            <Grid item xs={12} sm={6} md={4} lg={3}>
              <Typography variant="body1">
                <strong>Sub Service:</strong>{" "}
                {sub_service || sub_service_id?.name}
              </Typography>
            </Grid>

            <Grid item xs={12} sm={6} md={4} lg={3}>
              <Typography variant="body1">
                <strong>Advisor:</strong> {assign_to?.first_name}{" "}
                {assign_to?.last_name}
              </Typography>
            </Grid>

            {enquiryData?.enq_parent_id && (
              <Grid item xs={12} sm={6} md={4} lg={3}>
                <Typography variant="body1">
                  <strong>Class:</strong> {enquiryData?.enq_parent_id?.grade}
                </Typography>
              </Grid>
            )}

            {enquiryData?.enq_parent_id && (
              <Grid item xs={12} sm={6} md={4} lg={3}>
                <Typography variant="body1">
                  <strong>Parent Name:</strong>{" "}
                  {enquiryData?.enq_parent_id?.parent_name}
                </Typography>
              </Grid>
            )}
          </Grid>
        </Box>
      </Card>

      <CustomSnackbar
        open={snackbarOpen}
        onClose={() => setSnackbarOpen(false)}
        message={snackbarMessage}
        severity={snackbarSeverity}
      />

      <CustomPopup
        open={openEnquiryTransfer}
        onClose={handlecloseEnquiryTransfer}
        component={
          <RecycleOneEnquiryTransfer
            onClose={handlecloseEnquiryTransfer}
            selectedEnquiryIds={id}
            recycleRequestId={recycleRequestId}
          />
        }
        title="Reopen Enquiry"
        maxWidth="xs"
        showDivider={true}
      />

      <CustomPopup
        open={openCancelpopup}
        onClose={handleCloseCancelPopup}
        component={
          <CancelRecycleRequest
            onClose={handleCloseCancelPopup}
            selectedEnquiryIds={id}
            recycleRequestId={[recycleRequestId]}
          />
        }
        title="Recycle Response"
        maxWidth="xs"
        showDivider={true}
      />

      <CustomPopup
        open={openAccept}
        onClose={handleCloseAcceptPopup}
        component={
          <AcceptRecycleWithNote
            selectedId={[recycleRequestId]}
            // handleUpdateStatus={handleAcceptRecycleRequest}
            id={id}
          />
        }
        title="Accept Recycle Request"
        maxWidth="xs"
        showDivider={true}
      />

      {/* <AcceptConfirmationPopup
        open={openAccept}
        onClose={handleCloseAcceptPopup}
        title="Confirmation"
        component=""
        maxWidth="xs"
        showDivider={true}
        textBody="Are you sure you want to accept the recycle request ?"
        handleUpdateStatus={handleAcceptRecycleRequest}
        selectedId={[recycleRequestId]}
      /> */}
    </>
  );
};

export default EnquiryDetailsCard;
